var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitorDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#727271",
    d: "M17.93 0A6.04 6.04 0 0 1 24 6.05v6a6.04 6.04 0 0 1-6.06 6.06H12.5v1.13A2.76 2.76 0 0 1 9.73 22H7.07a.93.93 0 1 1 0-1.86h2.66a.9.9 0 0 0 .9-.9V18.1H6.05A6.04 6.04 0 0 1 0 12.05v-6A6.04 6.04 0 0 1 6.05 0h11.88zm2.96 3.1a4.18 4.18 0 0 0-2.96-1.24H6.06a4.19 4.19 0 0 0-4.2 4.2v5.99a4.18 4.18 0 0 0 4.2 4.2h11.87a4.17 4.17 0 0 0 4.2-4.2v-6c0-1.15-.48-2.2-1.24-2.95zM9.3 7.68a.93.93 0 1 1 1.32-1.32l1.37 1.38 1.38-1.38a.93.93 0 1 1 1.32 1.32L13.3 9.05l1.38 1.38a.93.93 0 1 1-1.32 1.32l-1.38-1.38-1.37 1.38a.93.93 0 1 1-1.32-1.32l1.38-1.38L9.3 7.68zM14.03 22a.93.93 0 1 1 0-1.86h2.88a.93.93 0 1 1 0 1.86h-2.88z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h23.99v22H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorDelete);
export default __webpack_public_path__ + "static/media/monitor-delete.5a989ec2cccc75917afb5f07dc968f02.svg";
export { ForwardRef as ReactComponent };